







































import Vue from 'vue';

import Movie from '@/models/soukai/Movie';

import MoviePoster from '@/components/MoviePoster.vue';

export default Vue.extend({
    components: {
        MoviePoster,
    },
    props: {
        movie: {
            type: Movie,
            required: true,
        },
    },
    computed: {
        linkTitle(): string {
            if (this.$viewer.isActive)
                return this.movie.title;

            const status = this.movie.watched ? 'Watched' : 'Watch later';

            return `${this.movie.title} (${status})`;
        },
    },
    methods: {
        async markWatched(e: Event) {
            if (this.movie.watched)
                return;

            e.preventDefault();

            await this.$ui.updateModel(this.movie, movie => movie.watch());
        },
    },
});
